import React from "react";

const AttendanceRulesTab = ({ darkMode }) => {
  return (
    <div className="p-4 lg:p-6">
      <h3 className="ds-h3 mb-2 text-[hsl(var(--ds-fg))]">Attendance Rules</h3>
      <p className="ds-body text-[hsl(var(--ds-muted-fg))]">
        Configure attendance rules and policies.
      </p>
    </div>
  );
};

export default AttendanceRulesTab;
